export default __webpack_public_path__ + "static/media/flower1.db9bdfff.jpg";